import { CmsValue } from 'core/type/BootstrapConfig.types';
import { CategoryCms, CategoryCodes, CategoryId } from 'core/type/Category.types';
import { RecentSearchItem, SuggestionResult } from 'core/type/SuggestionResult.types';
import { ActivityCardProps } from 'core/type/ActivityCard.types';

export const getCategoryName = (suggestion: SuggestionResult | RecentSearchItem, cms: CmsValue): string => {
    type CategoryIdType = keyof typeof CategoryId;
    type CategoryCodeType = keyof typeof CategoryCodes;

    if ('categories' in suggestion && suggestion?.categories?.[0]?.code) {
        const suggestedCategoryCode = suggestion.categories[0].code as CategoryCodeType;
        const categoryCode = CategoryCodes[suggestedCategoryCode] as CategoryIdType;
        return cms[CategoryCms[categoryCode]];
    }
    if ('categoryCode' in suggestion && suggestion?.categoryCode) {
        const categoryCode = CategoryCodes[suggestion.categoryCode as CategoryCodeType] as CategoryIdType;
        return cms[CategoryCms[categoryCode]];
    }
    return '';
};

export const getCategoryNameFromActivity = (activityCardProps: ActivityCardProps, cms: CmsValue): string => {
    if ('categories' in activityCardProps && activityCardProps.categories?.[0]) {
        const suggestedCategoryCode = activityCardProps.categories?.[0] as CategoryId;
        return cms[CategoryCms[suggestedCategoryCode]];
    }
    return '';
};
